export { default } from "./StrainReviewCard";
